import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { getFacultyMenuItems } from "../../services/MenuService";

const TeacherMenu = ({
  dashboardView = "standard",
  onDashboardViewChange = () => {},
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_user] = useLocalStorage("Auth", "user", null);
  const [_menuItems] = useState(getFacultyMenuItems(_school, _jwt, _user));

  useEffect(() => {});

  const handleNav = (item) => {
    if (item.dashboardView != null) {
      onDashboardViewChange(item.dashboardView);
    }

    navigate(item.path);
  };

  const isSelected = (item) => {
    if (item.path == null || item.path !== location.pathname) {
      return false;
    }

    if (item.dashboardView != null) {
      return item.dashboardView === dashboardView;
    }

    return true;
  };

  const isVisible = (item) => {
    const standardViewHiddenItemIds = [
      "homeroom",
      "about",
      "recommend",
      "bulk-delete",
      "my-events",
      "this-week",
      "next-week",
      "this-month",
      "next-month",
      "calendar",
      "daily-roster",
      "student-lists",
      "find-student",
      "add-scores", "manage-scores",
      "score-history", "fulfillments",
      "my-calendar", "my-meetings", "my-events",
    ];

    if (
      dashboardView === "standard" &&
      standardViewHiddenItemIds.includes(item.id)
    ) {
      return false;
    }

    return true;
  };

  const getVisibleMenuItems = () => {
    const visibleItems = _menuItems.filter(isVisible);

    return visibleItems.filter((item, index) => {
      if (item.isHeader !== true) {
        return true;
      }

      const nextHeaderIndex = visibleItems.findIndex(
        (nextItem, nextIndex) => nextIndex > index && nextItem.isHeader === true,
      );
      const endIndex =
        nextHeaderIndex === -1 ? visibleItems.length : nextHeaderIndex;

      return visibleItems
        .slice(index + 1, endIndex)
        .some((nextItem) => nextItem.isHeader !== true);
    });
  };

  const visibleMenuItems = getVisibleMenuItems();

  return (
    <Paper sx={{ mt: 1 }}>
      <MenuList>
        {visibleMenuItems.map((item, i) => (
          <Fragment key={`${item.id || item.path || item.url || item.text}-${i}`}>
            {item.isHeader === true && (
              <>
                {i !== 0 && <Divider />}
                <MenuItem sx={{ pt: 0, pb: 0, mt: 0, mb: 0 }}>
                  <Typography className="menuHeader">{item.text}</Typography>
                </MenuItem>
              </>
            )}

            {item.isHeader !== true && (
              <>
                <MenuItem selected={isSelected(item)} sx={{ pt: 0, pb: 0.0 }}>
                  {item.path && (
                    <Link
                      sx={{ ml: 0.5 }}
                      onClick={() => handleNav(item)}
                      className="menuLink"
                    >
                      {item.text}
                    </Link>
                  )}
                  {item.url && (
                    <Link
                      sx={{ ml: 0.5 }}
                      href={item.url}
                      target="_blank"
                      className="menuLink"
                    >
                      {item.text}
                    </Link>
                  )}
                </MenuItem>
              </>
            )}
          </Fragment>
        ))}
      </MenuList>
    </Paper>
  );
};

export default TeacherMenu;
